import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewIcon from "../../../components/Icons/ViewIcon";
import CommonTable from "../../../components/comman/CommonTable";
import { formatAmount } from "../../../utility/CommonFunctions";

const PendingInvoice = ({ siteId }) => {
  const navigate = useNavigate();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    invoiceList: [],
  });

  useEffect(() => {
    GetInvoiceList();
  }, [siteId]);

  const GetInvoiceList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_invoice + "?" +
      `pageNumber=1&pageSize=5&from=dashboard${siteId ? `&siteId=${siteId}` : ""}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.invoice?.map((item) => ({
          ...item,
          inDate: moment(item?.invoiceDate).format("DD-MM-YYYY"),
          siteName: item?.workorder?.site?.name,
          workOrder: item?.workorder?.title,
          total: formatAmount(item?.grossAmount),
          recievedAmt: formatAmount(item?.receivedAmount || 0)
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          invoiceList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "invoiceNumber", label: "INV NO." },
    { value: "inDate", label: "Invoice Date" },
    { value: "siteName", label: "site " },
    { value: "workOrder", label: "work Order" },
    { value: "total", label: "Total Amount" },
    { value: "recievedAmt", label: "Recieved Amount" },
  ];

  const HandleView = (data) => {
    navigate(RoutesLink.invoice_detail + `/${data?.id}`);
  };

  const ActionDataForPending = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];
  return (
    <div className="col-12 col-lg-6">
      <div className="card">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Pending Invoice</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.invoice)}
            >
              View All
            </button>
          </div>
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.invoiceList}
            ActionData={ActionDataForPending}
            isLoading={pageStates?.tableLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingInvoice;
